import React, {Component} from 'react';
import {gpn} from "../GPN"
import Back from "../sections/Back";
import Field from "../sections/MUI/Field";
import req from "../req";
import config from "../config";
import InfiniteScroll from "react-infinite-scroller";
import Collapsible from "react-collapsible";
import Select from "../sections/MUI/Select";
import Button from "../sections/MUI/Button";
import {toast} from "react-toastify";
import Icon from "../sections/MUI/Icon";
import Modal from "../sections/MUI/Modal";

class Orders extends Component {

    state = {
        orders: [],
        page: 1,
        hasNextPage: true,
        totalPages: null,

        adminDescriptions: [],

        editStepIndex: -1,

        status: "همه",
        search: ""
    };

    componentDidMount() {
        config.scrollTop();
        this.getAdminDescriptions();

    }

    getAdminDescriptions() {
        req.post(`/admin-description`, {action: "list"})
            .then(r => {
                this.setState({
                    adminDescriptions: r.descriptions
                });
            });
    }

    statusColor(status = "") {
        let color = "#FF3D00";
        if (status.includes("سفارش موفق") || status.includes("واریز شده")) {
            color = "#139f01";
        } else if (status.includes("لغو") || status.includes("واریز نشده") || status.includes("ناموفق")) {
            color = "#c00e0e"
        } else if (status.includes("اولیه") || status.includes("نامشخص")) {
            color = "#959595"
        }
        return color;
    }

    getOrders(page, search = "", status = "همه") {
        req.get(`/order?page=${page}&s=${search}&status=${status}`)
            .then(r => {
                const orders = r;
                this.setState({
                    orders: page > 1 ? [...this.state.orders, ...orders.docs] : orders.docs,
                    page: page + 1,
                    hasNextPage: orders.hasNextPage,
                    totalPages: orders.totalPages
                });
            });
    }

    delete(index = -1, id = "") {
        let {orders} = this.state;
        toast.info("در حال حذف ...");

        req.delete(`/order?id=${id}`)
            .then(r => {
                toast.success("با موفقیت حذف شد!");
                if (index !== -1) {
                    orders.splice(index, 1);
                    this.setState({
                        orders
                    });
                }
            })
            .catch(err => {
                config.handleError(err);
            });

    }


    setStatusAndDescriptionAdmin(id = "", status = "", adminDescription = "") {
        toast.info("در حال ثبت توضیحات و وضعیت ...");
        req.put(`/order`, {
            id,
            status,
            description: adminDescription
        })
            .then(r => {
                toast.success("با موفقیت ثبت شد.");
            })
            .catch(err => {
                config.handleError(err);
            });
    }

    handleInputStepChange(value = "") {
        let {orders, editStepIndex} = this.state;
        if (editStepIndex === -1) {
            return false;
        }
        orders[editStepIndex]["step"] = value;
        this.setState({orders});
    }

    submitStep() {
        let {orders, editStepIndex} = this.state;
        if (editStepIndex === -1) {
            return false;
        }
        let {id, step} = orders[editStepIndex];
        toast.info("در حال ثبت مرحله سفارش ...", {autoClose: 1500});
        req.post(`/order/step`, {
            id,
            step: step.toString().trim()
        })
            .then(r => {
                toast.success("با موفقیت ذخیره شد.", {autoClose: 1200});
            })
            .catch(err => {
                config.handleError(err);
            });
    }

    handleInputSearchChange(value = "") {
        this.setState({
            search: value
        });
        try {
            clearTimeout(this.timeout);
        } catch (err) {
        }
        this.timeout = setTimeout(() => {
            this.getOrders(1, value, this.state.status);
        }, value.toString().trim() === "" ? 300 : 1000);
    };

    render() {
        let {
            orders, page, hasNextPage, status, search, adminDescriptions,
            editStepIndex
        } = this.state;
        return (
            <div className="orders">
                {
                    editStepIndex !== -1 ?
                        <Modal title="ثبت مرحله سفارش"
                               icon="refresh"
                               display={editStepIndex !== -1}
                               onCloseClick={() => this.setState({editStepIndex: -1})}>

                            <div className="row justify-content-center">
                                <div className="col-xl-7 col-lg-8 col-md-6">
                                    <Select
                                        name="step"
                                        value={orders[editStepIndex].step}
                                        onChange={(name, value) => {
                                            this.handleInputStepChange(value)
                                        }}
                                        simple
                                        placeholder="انتخاب مرحله سفارش ..."
                                        options={[
                                            {t: "ثبت شده", v: "ثبت شده"},
                                            {t: "در انتظار تشکیل پرونده", v: "در انتظار تشکیل پرونده"},
                                            {t: "در انتظار رفع نواقص پرونده", v: "در انتظار رفع نواقص پرونده"},
                                            {t: "در انتظار تکمیل پرونده", v: "در انتظار تکمیل پرونده"},
                                            {t: "در انتظار ارسال مدارک", v: "در انتظار ارسال مدارک"},
                                            {t: "تحویل مدارک", v: "تحویل مدارک"},
                                            {t: "در انتظار بررسی پرونده", v: "در انتظار بررسی پرونده"},
                                            {t: "درانتظار تایید پرونده", v: "درانتظار تایید پرونده"},
                                            {t: "ارسال به واحد مالی و تأمین کالا", v: "ارسال به واحد مالی و تأمین کالا"},
                                            {t: "در انتظار تحویل کالا", v: "در انتظار تحویل کالا"},
                                            {t: "در انتظار تسویه کالا", v: "در انتظار تسویه کالا"},
                                            {t: "تسویه نهایی انجام شد", v: "تسویه نهایی انجام شد"}
                                        ]}/>
                                    <Field name="step"
                                           value={orders[editStepIndex].step}
                                           label="مرحله دلخواه"
                                           maxLength={500}
                                           onChange={(name, value) => this.handleInputStepChange(value)}/>

                                    <br/>
                                    <Button icon="check" onClick={() => this.submitStep()}>ذخیره کردن</Button>
                                </div>
                            </div>
                        </Modal>
                        : null
                }
                <Back {...this.props}/>
                <br/>
                <div className="row justify-content-center">
                    <div className="col-md-5">
                        <Select name="status"
                                value={status}
                                label="وضعیت سفارش"
                                onChange={(name, value) => {
                                    this.setState({[name]: value});
                                    this.getOrders(1, search, value);
                                }}
                                options={[
                                    {t: "همه موارد", v: "همه"},
                                    {t: "ثبت اولیه", v: "ثبت اولیه"},
                                    {t: "در دست بررسی", v: "در دست بررسی"},
                                    {t: "واریز شده", v: "واریز شده"},
                                    {t: "واریز نشده", v: "واریز نشده"},
                                    {t: "لغو شده", v: "لغو شده"},
                                    {t: "سفارش موفق", v: "سفارش موفق"},
                                    {t: "سفارش ناموفق", v: "سفارش ناموفق"},
                                    {t: "نامشخص", v: "نامشخص"}
                                ]}/>
                    </div>
                    <div className="col-md-5">
                        <div className="label-hint"
                             style={{
                                 textAlign: "center",
                                 fontSize: "10pt",
                                 marginTop: 8,
                                 color: "#656565"
                             }}>کد سفارش، نام، نام خانوادگی، شماره موبایل یا کد ملی:
                        </div>
                        <Field name="search"
                               value={search}
                               label="جستجو ..."
                               style={{direction: config.isFa(search) ? "rtl" : "ltr"}}
                               maxLength={100}
                               onChange={(name, value) => {
                                   this.handleInputSearchChange(value);
                               }}/>
                    </div>

                </div>


                <br/>

                <div className="list">
                    <InfiniteScroll
                        pageStart={1}
                        loadMore={() => this.getOrders(page, search, status)}
                        hasMore={hasNextPage}
                        loader={<div className="loader" key={0}>دریافت ...</div>}>
                        {
                            orders ? orders?.map((o, i) =>
                                    <article key={"order" + i}>
                                        <Collapsible
                                            trigger={
                                                <div className="collapse-header">
                                                    <div className="user">
                                                        <div className="row">
                                                            <div className="status-circle"
                                                                 style={{backgroundColor: this.statusColor(o.status)}}>
                                                            </div>
                                                            {
                                                                o.user ?
                                                                    <>
                                                                        <div className="col-auto">
                                                                            <div
                                                                                className="full-name">{o.user.fullName}</div>
                                                                        </div>
                                                                        <div className="col-auto">
                                                                            <div
                                                                                className="phone">({o.user.phone})
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-auto">
                                                                            <div className="code">
                                                                                <span>کد:</span><span>{o.code}</span></div>
                                                                        </div>
                                                                    </>
                                                                    :
                                                                    <>
                                                                        <div className="col-auto">
                                                                            <div
                                                                                className="full-name">نامشخص
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-auto">
                                                                            <div
                                                                                className="phone">(این کاربر وجود ندارد)
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-auto">
                                                                            <div className="code">
                                                                                <span>کد:</span><span>{o.code}</span></div>
                                                                        </div>
                                                                    </>
                                                            }
                                                        </div>

                                                    </div>
                                                </div>
                                            }
                                            transitionTime={50}>
                                            <div className="body">
                                                {o.form.length > 0 ?
                                                    <div className="order-form">
                                                        <div className="title">فرم</div>
                                                        {o.form.map((f, fi) =>
                                                            <p key={"form" + fi}>
                                                                <span>{f.title}:</span><span>{f.value}</span>
                                                            </p>
                                                        )}
                                                    </div>
                                                    : null}
                                                {o.facilities.length > 0 ?
                                                    <div className="order-facilities">
                                                        <div className="title">طرح ها</div>
                                                        {o.facilities.map((f, fi) =>
                                                            <p key={"facilities" + fi}>
                                                                <span>{f.title}:</span><span>{config.priceFormatter(f.registerPrice)}&nbsp;تومان</span>
                                                            </p>
                                                        )
                                                        }
                                                    </div>
                                                    : null}
                                                {o.services.length > 0 ?
                                                    <div className="order-services">
                                                        <div className="title">خدمات</div>
                                                        {o.services.map((f, fi) =>
                                                            <p key={"services" + fi}>
                                                                <span>{f.title}:</span><span>{config.priceFormatter(f.price)}&nbsp;تومان</span>
                                                            </p>
                                                        )
                                                        }
                                                    </div>
                                                    : null}

                                                <p className="status"><span>وضعیت:</span><span
                                                    style={{color: this.statusColor(o.status)}}>{o.status}</span></p>

                                                <div className="step">
                                                    <p className="t">فرآیند سفارش:</p>
                                                    <div className="row">
                                                        <p className="step-text">{o.step ? o.step.toString().trim() !== "" ? o.step.toString().trim() : "-" : "-"}</p>
                                                        <Icon i="refresh" className="step-icon"
                                                              onClick={() => this.setState({editStepIndex: i})}/>
                                                    </div>
                                                </div>
                                                <p className="created-at"><span>ثبت شده در:</span><span>{o.createdAt}</span>
                                                </p>

                                                <div className="otp">
                                                    <Select name="status"
                                                            value={o.status}
                                                            label="وضعیت"
                                                            onChange={(name, value) => {
                                                                let mOrders = orders;
                                                                mOrders[i]["status"] = value;
                                                                this.setState({orders: mOrders});
                                                            }}
                                                            options={[
                                                                {t: "ثبت اولیه", v: "ثبت اولیه"},
                                                                {t: "در دست بررسی", v: "در دست بررسی"},
                                                                {t: "واریز شده", v: "واریز شده"},
                                                                {t: "واریز نشده", v: "واریز نشده"},
                                                                {t: "لغو شده", v: "لغو شده"},
                                                                {t: "سفارش موفق", v: "سفارش موفق"},
                                                                {t: "سفارش ناموفق", v: "سفارش ناموفق"},
                                                                {t: "نامشخص", v: "نامشخص"}
                                                            ]}/>

                                                    <Select name="adminDescription"
                                                            value={o.adminDescription}
                                                            placeholder="توضیحات مدیریت"
                                                            label="توضیحات مدیریت"
                                                            options={adminDescriptions.map(d => {
                                                                return {t: d, v: d}
                                                            })}
                                                            onChange={(name, value) => {
                                                                let mOrders = orders;
                                                                mOrders[i]["adminDescription"] = value;
                                                                this.setState({orders: mOrders});
                                                            }}/>
                                                    <p style={{
                                                        color: "#656565",
                                                        fontSize: "10pt",
                                                        textAlign: "center"
                                                    }}>{o.adminDescription}</p>

                                                    {/*<Field name="adminDescription"*/}
                                                    {/*       value={o.adminDescription}*/}
                                                    {/*       maxLength={5000}*/}
                                                    {/*       label="توضیحات مدیریت"*/}
                                                    {/*       row={3}*/}
                                                    {/*       type="textarea"*/}
                                                    {/*       onChange={(name, value) => {*/}
                                                    {/*           let mOrders = orders;*/}
                                                    {/*           mOrders[i]["adminDescription"] = value;*/}
                                                    {/*           this.setState({orders: mOrders});*/}

                                                    {/*       }}/>*/}
                                                    <div className="row justify-content-center">
                                                        <div className="col-md-5">
                                                            <Button icon="check"
                                                                    onClick={() => this.setStatusAndDescriptionAdmin(o.id, o.status, o.adminDescription)}>ذخیره
                                                                وضعیت و توضیحات</Button>
                                                        </div>
                                                    </div>

                                                    <br/><br/>
                                                    <div className="row justify-content-end">
                                                        <div className="col-4">
                                                            <Button icon="trash"
                                                                    backgroundColor="#c00e0e"
                                                                    onDoubleClick={() => this.delete(i, o.id)}>حذف
                                                                سفارش</Button>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </Collapsible>


                                    </article>)
                                : null
                        }
                    </InfiniteScroll>
                </div>
            </div>
        );
    }
}

export default gpn(Orders);